// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Library Imports
import { Form, Input } from "antd";

// Local Imports
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";
import LoginService from "./login-service";
import { FormValues } from "./types";
import TestingEnvLabel from "src/components/testign-env-label.component";

const Login: React.FC = (): ReactElement => {
  const loginService = new LoginService();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submitLoginForm, setSubmitLoginForm] = useState<boolean>(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmitLoginForm(true);
      },
      () => {
        setSubmitLoginForm(false);
      }
    );
  }, [values]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-no-repeat bg-cover bg-bottom p-3 md:p-5 box-border bg-[login-background]">
      <div className="flex flex-col rounded-[20px] p-5 md:p-10 w-full md:w-[526px] bg-white box-border">
        <div className="flex items-center justify-center">
          {/* <img
            className="w-[120px] md:w-[184px] h-[54px] mb-5"
            src={"/images/login-logo.svg"}
            alt="Kamco logo invest kamcoInvest"
          /> */}
          <TestingEnvLabel classes="mb-5" />
        </div>
        <h4 className=" text-lg md:text-3xl text-blue-400 font-semibold">
          Sign in
        </h4>
        <p className=" text-sm md:text-base text-gray-200 mt-2">
          Welcome to your Kamco account
        </p>
        <Form
          form={form}
          onFinish={(values: FormValues) => loginService.onSubmit(values)}
          initialValues={{ email: null, password: null }}
          name="login-form"
          className="mt-5"
          layout="vertical"
        >
          <div className="flex flex-col w-full">
            <Label text="Email address" />
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
                {
                  type: "email",
                },
              ]}
            >
              <CustomInput placeholder="Type Your Email" />
            </Form.Item>
          </div>
          <div className="flex flex-col w-full">
            <Label text="Password" />
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your Password!",
                },
              ]}
            >
              <Input.Password
                className="input-field-container"
                placeholder="Type Your Password"
                // autoComplete="new-password"
              />
            </Form.Item>
          </div>
          <Form.Item className="mb-0">
            <button
              className="flex cursor-pointer w-full items-center hover:text-white justify-center mt-4 border-0 shadow-none text-white bg-blue-500 h-[57px] text-lg rounded-lg font-semibold disabled:text-white disabled:bg-blue-100"
              disabled={!submitLoginForm}
            >
              Login
            </button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
